import { css, Theme } from '@emotion/react'
import { accordionClasses, accordionSummaryClasses } from '@mui/material'
import { getAsHtmlBaseStyles } from 'pagesNew/Emails/emailStyles'

export const headSubtitle = (theme: Theme) => css`
  display: block;
  font-weight: 500;
  font-size: 20px;
  padding-bottom: ${theme.spacing(1)};
`

export const sectionTitle = (theme: Theme) => css`
  font-size: 16px;
  color: ${theme.typographyColors.typographyThree};
  margin-top: ${theme.spacing(2)};
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(3, 0, 3)};
`

export const accordion = (theme: Theme) => css`
  &.${accordionClasses.root} {
    border-radius: 14px;
    border: 1px solid ${theme.colors.backgroundOne};
    box-shadow: ${theme.boxShadows.small};
    margin: 10px 0;
    overflow: hidden;

    :before {
      display: none;
    }
  }
`

export const accordionEmpty = (theme: Theme) => css`
  &.${accordionClasses.root} {
    border: 1px solid ${theme.colors.red};
  }
`

export const accordionSingle = css`
  &.${accordionClasses.root} {
    margin: 0;
  }
`

export const accordionSummary = (theme: Theme) => css`
  &.${accordionSummaryClasses.root} {
    height: 48px;
    min-height: 48px;
    max-height: 48px;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 0;
    background: ${theme.backgrounds.backgroundFive};
    border-bottom: 1px solid ${theme.colors.backgroundOne};
    box-shadow: ${theme.boxShadows.small};
    margin-bottom: -1px;

    .${accordionSummaryClasses.content} {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 0;
    }
  }
`

export const accordionSummaryBlock = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const accordionSummaryTitleBlock = css`
  gap: 0;
`

export const title = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 500;
  max-width: 574px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const index = (theme: Theme) => css`
  width: 36px;
  color: ${theme.typographyColors.typographyThree};
  line-height: 20px;
  font-weight: 700;
  text-align: center;
`

export const icon = (theme: Theme) => css`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  padding: 8px;
  gap: 5px;
  border-radius: 10px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
`

export const iconEdit = (theme: Theme) => css`
  color: ${theme.backgrounds.backgroundOne};
`

export const iconChevron = (theme: Theme) => css`
  width: 24px;
  height: 24px;
  transform: rotate(0);
  transition: transform 0.25s linear;
  color: ${theme.typographyColors.typographyThree};
`

export const iconChevronOpen = css`
  transform: rotate(180deg);
`

export const accordionDetails = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 15px;
`

export const htmlBlock = (theme: Theme) => css`
  font-size: 14px;
  color: ${theme.typographyColors.typographyTwo};

  // add default borders for tables from parsed html
  table.table {
    border: 1px solid black;
    border-collapse: collapse;

    td,
    th {
      border: 1px solid black;
      border-collapse: collapse;
      padding: 4px;
    }

    thead td {
      border-bottom: double black 3pt;
    }
  }

  // add default styles for lists from parsed html
  ol.upper-roman,
  ol.roman {
    li {
      list-style-type: upper-roman;
    }
  }
`

export const mainSolutionBlock = css`
  margin-top: 0;
`

export const mainSolutionVideoBlock = (theme: Theme) => css`
  font-size: 14px;
  color: ${theme.typographyColors.typographyTwo};
  margin-bottom: 8px;
`

export const solutionBlock = (theme: Theme) => css`
  ${getAsHtmlBaseStyles(theme)};
  min-height: 32px;
  padding: 6px 12px;
  border-radius: 8px;
  margin-top: 8px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
  color: ${theme.typographyColors.typographyTwo};
`

export const answer = css`
  position: relative;
  display: flex;
  gap: 4px;
`

export const answerLabel = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
  font-weight: 700;
`

export const correctAnswerIcon = css`
  margin: -1px 0 -2px 2px;
`

export const modalContainerWrapper = css`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const modalContainer = (theme: Theme) => css`
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 24px;
  padding: 16px;
  width: 900px;
  max-width: calc(100% - 40px);
  box-sizing: border-box;
  max-height: 95vh;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const modalForm = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const modalTitle = css`
  font-weight: 700;
  text-align: center;
`

export const history = css`
  margin: 16px 0;

  div {
    gap: 16px;
  }
`
